export const AppName = `s20024's Portfolio`;

export const GithubUrl = 'https://github.com/s20024';
export const TwitterUrl = 'https://x.com/s20024itcollege';
export const MailUrl = 'mailto:s20024@std.it-college.ac.jp';

// memo: package.jsonのhomepage(配信先サブパス)に追従するベースURL。開発時は空文字になる。
export const BaseUrl = process.env.PUBLIC_URL ?? '';

/**
 * publicディレクトリ配下の静的アセットのパスを、配信先のサブパスを考慮して解決する。
 * @param path 先頭をスラッシュで始めるアセットパス (例: '/images/github.png')
 * @returns BaseUrlを付与した解決済みのパス
 */
export const asset = (path: string): string => `${BaseUrl}${path}`;
